var Aneox;
(function (Aneox) {
  (function (Sequences) {
    'use strict';

    var Vintages = (function () {

      var self;
      var animations;
      var timeline;

      var hasPlayedThroughAnimation = {};

      function Vintages(anims) {
        self = this;
        animations = anims;
        
        timeline = new TimelineMax({ paused: true });

        timeline
        .add(animations.OpeningTimeline($('#vintages-opening')))
        .addPause()
        .addLabel('main');
        var intros = $('.vintage-intro');
        intros.each(function(index) {
          index = intros.length - index;
          timeline
          .add(animations.SubtitleTimeline($(this).children('.vintage-inline-title')), 'main+=' + (index * .5))
          .staggerFrom($(this).children('p, button'), .5, { opacity: 0 }, .1, 'main+=' + ((index * .5) + .5));
          var hr = $(this).children('.hr');
          if (hr.length > 0) {
            timeline.from(hr, 1, {
              scaleX: 0
            }, 'main+=.8');
          }
        });
      }

      Vintages.prototype.mastEnterAnimation = function() {
        timeline.play();
      };

      Vintages.prototype.mainEnterAnimation = function() {
        if (timeline.time() > timeline.getLabelTime('main')) return;
        timeline.seek('main').play();
      }

      Vintages.prototype.fastForwardAnimations = function() {
        timeline.pause().progress(1);
      };

      Vintages.prototype.resetAnimations = function() {
        timeline.pause().progress(0);
      }

      Vintages.prototype.handleWindowResize = function(bodyWidth, bodyHeight) {

      };


      return Vintages;
    })();

    Sequences.Vintages = Vintages;
  })(Aneox.Sequences || (Aneox.Sequences = {}));
})(Aneox || (Aneox = {}));